import { useContext } from "react";
import useSWRMutation from "swr/mutation";
import { environment } from "../config/environment";
import { ToastContext } from "../context/ToastContext";
import { ChaseInvoicesRequestModel, ChaseInvoicesResponseModel } from "@attelas/shared";
import { useSWRFetcher } from "./useSWRFetcher";

export const useChaseInvoices = () => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { trigger, isMutating, error } = useSWRMutation(
    `${environment.apiUrl}/api/chases/external/multiple`,
    (url: string, { arg }: { arg: ChaseInvoicesRequestModel }) =>
      fetcher<ChaseInvoicesResponseModel>(url, {
        method: "POST",
        body: JSON.stringify(arg),
      }),
    {
      onError: () => {
        showToast("Failed to chase multiple invoices, please try again later", "error");
      },
    }
  );

  return {
    chaseInvoices: trigger,
    isLoading: isMutating,
    isError: !!error,
  };
};
